import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import Loader from "../../../components/widgets/loader.vue";
import simplebar from "simplebar-vue";
import { NotificationsModule } from "@/store/modules/notification.module";
import TransferOwnershipComponent from "./components/TransferOwnershipComponent.vue";
import MemberAdditionComponent from "./components/MemberAdditionComponent.vue";
import RequestTrackingComponent from "./components/RequestTrackingComponent.vue";
import notificationMachine from "./machines/notificationMachine";
import { interpret } from "xstate/lib/interpreter";
import AcceptedProjectRequestComponent from "./components/AcceptedProjectRequestComponent.vue";
import ConvertTaskToProjectComponent from "./components/ConvertTaskToProjectComponent.vue";
import ReviewNotificationComponent from "./components/ReviewNotificationComponent.vue";
import ReviewMeetingNotificationComponent from "./components/ReviewMeetingNotificationComponent.vue";
import RequestedProjectRejectionNotificationComponent from "./components/RequestedProjectRejectionNotificationComponent.vue";
import HostileTakeOverNotificationComponent from "./components/HostileTakeOverNotificationComponent.vue";
/**
 * Notification Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let Notification = /** @class */ (() => {
    let Notification = class Notification extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Notification";
            this.count = 0;
            this.tenantId = localStorage.getItem("tenantId");
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Notification",
                    active: true,
                },
            ];
            this.machine = notificationMachine.withContext({
                skipCount: 0,
                isNew: true,
                filterType: "All",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.spinnerClass = false;
        }
        //Computed
        get notifications() {
            return NotificationsModule.notifications;
        }
        get notification() {
            return this.notifications;
        }
        get totalCount() {
            return NotificationsModule.totalCount;
        }
        get shouldShowLoadMore() {
            if (this.state.context.filterType === "All") {
                return this.totalCount > 20 && this.totalCount !== this.notifications.length;
            }
            else if (this.state.context.filterType === "UnSeen") {
                return this.unreadNotificationCount > 20 && this.unreadNotificationCount !== this.notifications.length;
            }
            else if (this.state.context.filterType === "RequestTracking") {
                return this.pendingRequestTrackingCount > 20 && this.pendingRequestTrackingCount !== this.notifications.length;
            }
            return false;
        }
        get unreadNotificationCount() {
            return NotificationsModule.unreadNotificationCount;
        }
        get pendingRequestTrackingCount() {
            return NotificationsModule.requestTrackingPendingCount;
        }
        // Methods
        RemoveNotification(notification) {
            const index = this.notifications.indexOf(notification);
            if (this.state.context.filterType != "All") {
                if (index !== -1) {
                    this.notifications.splice(index, 1);
                }
            }
        }
        LoadMore() {
            this.spinnerClass = true;
            switch (this.state.context.filterType) {
                case "All":
                    this.state.context.skipCount = this.notifications.length > 0 ? this.notifications.length : 0;
                    break;
                case "UnSeen":
                    this.state.context.skipCount = this.notifications.length > 0 ? this.notifications.length : 0;
                    break;
                case "RequestTracking":
                    this.state.context.skipCount = this.notifications.length > 0 ? this.notifications.length : 0;
                    break;
            }
            this.machineService.send({ type: "LOAD_MORE", skipCount: this.state.context.skipCount });
        }
        ShowUnReadNotifications() {
            if (this.state.context.filterType !== "UnSeen") {
                this.state.context.skipCount = 0;
            }
            this.machineService.send({ type: "UN_SEEN", filterType: "UnSeen" });
            NotificationsModule.ClearNotification();
        }
        ShowRequestTrackingNotifications() {
            if (this.state.context.filterType !== "RequestTracking") {
                this.state.context.skipCount = 0;
            }
            this.machineService.send({ type: "REQUEST_TRACKING", filterType: "RequestTracking" });
            NotificationsModule.ClearNotification();
        }
        ShowAllNotifications() {
            if (this.state.context.filterType !== "All") {
                this.state.context.skipCount = 0;
            }
            NotificationsModule.ClearNotification();
            this.machineService.send({ type: "ALL", filterType: "All" });
        }
        MarkAllAsRead() {
            if (this.unreadNotificationCount == 0) {
                return "";
            }
            this.machineService.send({ type: "MARK_ALL_AS_SEEN" });
        }
        updateIsAccept() {
            this.requestTrackingNotificationId = "";
        }
        //LifeCycle
        created() {
            NotificationsModule.ClearNotification();
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("notificationLoaded")) {
                    this.spinnerClass = false;
                }
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], Notification.prototype, "requestTrackingNotificationId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], Notification.prototype, "isAccept", void 0);
    Notification = __decorate([
        Component({
            name: "Notification",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                TransferOwnershipComponent,
                RequestTrackingComponent,
                MemberAdditionComponent,
                AcceptedProjectRequestComponent,
                ConvertTaskToProjectComponent,
                ReviewNotificationComponent,
                ReviewMeetingNotificationComponent,
                RequestedProjectRejectionNotificationComponent,
                HostileTakeOverNotificationComponent,
            },
        })
    ], Notification);
    return Notification;
})();
export default Notification;
